(() => {
  function ready() {
    if (!document.querySelector('pugs-reviews') || customElements.get('pugs-reviews')) return;
    const source = [...document.scripts].find(s => (s.src || s.dataset.src || '').split('?')[0].endsWith('/reviews.js'));
    if (!source || document.getElementById('fshop-review-app-loader')) return;
    const script = document.createElement('script');script.id = 'fshop-review-app-loader';script.src = source.src || source.dataset.src;document.head.append(script);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});else ready();
  document.addEventListener('shopify:section:load', ready);
})();
